import { useState } from 'react';
import { usePagination } from './pagination';

export const useOrders = (route = '/api/orders', perPage = 10) => {
    const [error, setError] = useState(null);
    const { 
        pagination, 
        loading, 
        fetchData: refreshOrders, 
        filters, 
        setFilters 
    } = usePagination(route);

    // Access orders directly from pagination.data
    const orders = pagination.data;

    // Pagination handlers
    const handleNextPage = () => {
        if (pagination.current_page < Math.ceil(pagination.total / pagination.per_page)) {
            setFilters({ ...filters, page: pagination.current_page + 1 });
        }
    };

    const handlePreviousPage = () => {
        if (pagination.current_page > 1) {
            setFilters({ ...filters, page: pagination.current_page - 1 });
        }
    };

    const handlePageChange = (pageNumber) => {
        setFilters({ ...filters, page: pageNumber });
    };

    return {
        orders,
        pagination,
        loading,
        error,
        refreshOrders,
        handleNextPage,
        handlePreviousPage,
        handlePageChange,
        filters,
        setFilters
    };
}; 